import { useState } from "react";
import { Music, X, ChevronUp } from "lucide-react";

export default function MusicPlayer() {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col items-end gap-2" data-testid="music-player">
      {open && (
        <div
          className="bg-paper border border-soft shadow-2xl overflow-hidden"
          style={{ width: "340px" }}
          data-testid="music-player-open"
        >
          <div className="flex items-center justify-between px-4 py-2 border-b border-soft bg-linen">
            <div className="flex items-center gap-2">
              <Music size={14} className="text-sand" />
              <p className="text-[10px] tracking-[0.22em] uppercase text-soft">Now playing</p>
            </div>
            <button
              onClick={() => setOpen(false)}
              className="text-soft hover:text-ocean transition-colors"
              aria-label="Close player"
              data-testid="music-player-close"
            >
              <X size={16} />
            </button>
          </div>
          <iframe
            title="Champagne & Sunshine — Apple Music"
            allow="autoplay *; encrypted-media *; clipboard-write"
            frameBorder="0"
            height="175"
            style={{ width: "100%", overflow: "hidden", background: "transparent" }}
            sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation"
            src="https://embed.music.apple.com/us/album/champagne-sunshine-single/1565623528"
          />
        </div>
      )}
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-4 py-3 shadow-lg hover:shadow-xl transition-all group"
        style={{ backgroundColor: "var(--primary)", color: "#fff" }}
        data-testid="music-player-toggle"
      >
        <Music size={16} className="text-sand" />
        <span className="text-xs tracking-[0.18em] uppercase hidden sm:inline">
          {open ? "Hide player" : 'Now playing · "Champagne & Sunshine"'}
        </span>
        <span className="text-xs tracking-[0.18em] uppercase sm:hidden">
          {open ? "Hide" : "Play"}
        </span>
        <ChevronUp
          size={14}
          className={`transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>
    </div>
  );
}
